import { useLanguage } from "providers/language";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import classNames from "classnames";
import { ButtonBase, Menu, MenuItem } from "@mui/material";
import { LANGUAGES, Language } from "types/locale";
import { ReactComponent as FlagLT } from "assets/flags/lt.svg";
import { ReactComponent as FlagGB } from "assets/flags/gb.svg";
import { FunctionComponent, SVGProps, useId, useState } from "react";
import { useDictionary } from "hooks/use-dictionary";

const FLAG_COMPONENTS: Record<Language, FunctionComponent<SVGProps<SVGSVGElement>>> = {
  [Language.Lt]: FlagLT,
  [Language.En]: FlagGB,
};

const LANGUAGE_LABELS: Record<Language, string> = {
  [Language.Lt]: "Lietuvių",
  [Language.En]: "English",
};

const LanguageSelect = () => {
  const { lang, setLang } = useLanguage();
  const dict = useDictionary();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const id = useId();
  const open = anchorEl !== null;
  const triggerId = `${id}-language-button`;
  const menuId = `${id}-language-menu`;
  const Flag = FLAG_COMPONENTS[lang];

  return (
    <>
      <ButtonBase
        type="button"
        id={triggerId}
        aria-label={dict.common.ariaLabels.selectLanguage}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        className="flex h-10 items-center cursor-pointer select-none !pl-2"
      >
        <Flag aria-hidden="true" className="w-6 h-4 rounded-sm" />
        <ArrowDropDown className={classNames({ "transform scale-y-[-1]": open })} />
      </ButtonBase>
      <Menu
        id={menuId}
        data-language-menu
        sx={{ zIndex: 10001 }}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{ "aria-labelledby": triggerId }}
      >
        {LANGUAGES.map((language) => {
          const OptionFlag = FLAG_COMPONENTS[language];
          return (
            <MenuItem
              key={language}
              role="menuitemradio"
              aria-checked={language === lang}
              selected={language === lang}
              onClick={() => {
                setLang(language);
                setAnchorEl(null);
              }}
              className="flex items-center gap-2"
            >
              <OptionFlag aria-hidden="true" className="w-6 h-4 rounded-sm" />
              <span>{LANGUAGE_LABELS[language]}</span>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default LanguageSelect;
